import { LoadingDots } from '@carboncopyco/ui';
import { AnimatePresence, motion } from 'framer-motion';

export interface BackdropProps {
  isOpen: boolean;
}

export const Backdrop = ({ isOpen }: BackdropProps) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            ease: 'easeInOut',
            duration: 0.2,
          }}
        >
          <div className="backdrop-blur-sm absolute inset-0 w-full h-full bg-white/50">
            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center">
              <LoadingDots />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
